import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface IUserState {
  isAdmin: boolean;
}

const initialState: IUserState = {
  isAdmin: false,
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setIsAdmin: (state, action: PayloadAction<{ value: boolean }>) => {
      state.isAdmin = action.payload.value;
    },
    setInitialState: (state) => {
      state.isAdmin = initialState.isAdmin;
    },
  },
});

export const { setIsAdmin, setInitialState } = userSlice.actions;

const UserReducer = userSlice.reducer;

export default UserReducer;
